import { request } from "../request";
const mock = "";
// const mock = "https://yapi.upho2015.com/mock/530";
// 前台-获取未读的列表状态
export const getMsgListState = (params) =>
  request(`${mock}/v1/msg/listState`, "get", { params });
// 前台-获取自己的消息列表
export const getMsgList = (params) =>
  request(`${mock}/v1/msg/list`, "get", { params });
